import React from 'react'

const Header = () => {
  return (
    <div className='w-full border shadow-lg fixed top-0 bg-white'>
      <header className='text-center py-5'>
        <h1 className='text-3xl font-bold uppercase'>CodeHelp Blogs</h1>
      </header>
    </div>
  )
}

export default Header
